import { render, staticRenderFns } from "./Finca.vue?vue&type=template&id=e9767d50&scoped=true"
import script from "./Finca.vue?vue&type=script&lang=js"
export * from "./Finca.vue?vue&type=script&lang=js"
import style0 from "./Finca.vue?vue&type=style&index=0&id=e9767d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9767d50",
  null
  
)

export default component.exports